import { PromptBlueprint } from "@/types/prompt-blueprint";

export const dataToPromptBlueprint = (apiData: any): PromptBlueprint => {
  const promptVersionData = apiData.prompt_version;

  return {
    prompt_template: promptVersionData.prompt_template,
    inference_client_name: promptVersionData.inference_client_name ?? null,
    commit_message: promptVersionData.commit_message ?? undefined,
    metadata: promptVersionData.metadata ?? undefined,
    report_id: promptVersionData.report_id ?? undefined,
    provider_base_url_name: promptVersionData.provider_base_url_name ?? null,
  };
};
